import { validateGreaterThan } from './validateGreaterThan';

export const validatePassword = validateGreaterThan<string>(7, () => 'Password must be at least 8 characters');
